import { SENTRY_DEFAULTS } from 'src/config/sentryDefaults.mjs';

const SAMPLE_RATE_FALLBACK = 0.1;

const parseOptionalNumber = (value?: string): number | undefined => {
  if (value == null || value === '') {
    return;
  }

  const parsedValue = Number.parseFloat(value);
  return Number.isFinite(parsedValue) ? parsedValue : undefined;
};

const parseSampleRate = (value?: string): number =>
  parseOptionalNumber(value) ?? SAMPLE_RATE_FALLBACK;

export const sentryConfig = {
  dsn: SENTRY_DEFAULTS.dsn,
  org: SENTRY_DEFAULTS.org,
  project: SENTRY_DEFAULTS.project,
  url: SENTRY_DEFAULTS.url,
  replaysOnErrorSampleRate: parseSampleRate(
    import.meta.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  ),
  replaysSessionSampleRate: parseSampleRate(
    import.meta.env.SENTRY_REPLAYS_SAMPLE_RATE,
  ),
  tracesSampleRate: parseSampleRate(import.meta.env.SENTRY_TRACES_SAMPLE_RATE),
} as const;
